var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"img-responsive app-logo",attrs:{"src":require("@/assets/img/logo.png"),"alt":_vm.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }